<template>
  <div class="app-main">
    <el-container style="border: 1px solid #eee">
      <div style="height:100%;background: #152857">
        <app-menu></app-menu>
      </div>
      <el-container>
        <el-header style="font-size: 12px">
          <app-header class="app-header"></app-header>
        </el-header>
        <el-main class="main-style">
          <transition name="fade-transform" mode="out-in">
            <div class="main-contents">
              <router-view :key="this.$route.path" />
            </div>
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import AppHeader from '@/components/layer/AppHeader'
import AppMenu from '@/components/layer/AppMenu'
import { getStorageItem } from '@/utils'

export default {
  name: 'AppMain',
  data() {
    return {
      userName: '',
      passwordFlag: getStorageItem('passwordFlag'),
      pwdEdit: Number(getStorageItem('passwordFlag')) === 1,
    }
  },
  created() {
    this.userName = getStorageItem('userName')
    if (this.$route.path === '/Pwd/LoginPwd') {
      this.pwdEdit = false
    }
  },
  components: {
    AppHeader,
    AppMenu,
  },
  methods: {},
}
</script>

<style scoped>
html,
body {
  width: 100%;
}
.app-main {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  /* min-width: 1280px; */
}

.main-style {
  /* margin: 20px; */
  padding: 20px;
  background: #eef1f7;
}
.main-contents{
     display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
    overflow: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 20px;
    background: #fff;
}
/*fade*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/*fade-transform*/
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.el-header {
  padding: 0;
  background: #fff;
}
.eef1f7 {
  background: #eef1f7;
}
</style>
